import * as React from 'react';

import { useId } from '@coursera/cds-core';

const SIZE_MAP = {
  small: { width: 16, height: 16 },
  medium: { width: 20, height: 20 },
  large: { width: 24, height: 24 },
} as const;

const SparkleOpenIcon = ({ size = 'large' }: { size: keyof typeof SIZE_MAP }) => {
  const { width, height } = SIZE_MAP[size];
  // Generate unique IDs for gradients to prevent collisions when multiple instances exist
  const uniqueId = useId();
  const radialGradientId = `sparkle-radial-${uniqueId}`;

  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" fill="transparent" />
      <path
        d="M26.2869 3.93962C27.3046 3.51205 28.3278 4.53529 27.9002 5.55291L25.5835 11.0668C24.3008 14.1196 24.3008 17.5601 25.5835 20.6129L27.9002 26.1268C28.3278 27.1444 27.3046 28.1676 26.2869 27.7401L20.7731 25.4233C17.7203 24.1406 14.2797 24.1406 11.2269 25.4233L5.71307 27.7401C4.69545 28.1676 3.67221 27.1444 4.09978 26.1268L6.41655 20.6129C7.69925 17.5601 7.69925 14.1196 6.41655 11.0668L4.09978 5.55291C3.6722 4.53529 4.69545 3.51205 5.71307 3.93962L11.2269 6.25639C14.2797 7.53909 17.7203 7.53909 20.7731 6.25639L26.2869 3.93962Z"
        fill={`url(#${radialGradientId})`}
      />
      <path
        d="M12.2978 16.2831C11.9007 16.121 11.9007 15.5587 12.2978 15.3966L13.9911 14.7052C14.3882 14.5431 14.7033 14.228 14.8654 13.8309L15.5567 12.1377C15.7189 11.7406 16.2811 11.7406 16.4433 12.1377L17.1346 13.8309C17.2967 14.228 17.6118 14.5431 18.0089 14.7052L19.7022 15.3966C20.0993 15.5587 20.0993 16.121 19.7022 16.2831L18.0089 16.9744C17.6118 17.1366 17.2967 17.4517 17.1346 17.8487L16.4433 19.542C16.2811 19.9391 15.7189 19.9391 15.5567 19.542L14.8654 17.8487C14.7033 17.4517 14.3882 17.1366 13.9911 16.9744L12.2978 16.2831Z"
        fill="#F2F5FA"
      />
      <defs>
        <radialGradient
          id={radialGradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.4375 3.27734) rotate(45) scale(34.7366 31.6063)"
        >
          <stop stopColor="#6923DE" />
          <stop offset="1" stopColor="#3286FF" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default SparkleOpenIcon;
